import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plan",
  "use": "icon-plan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-plan\"><path d=\"M960 1024H64a64 64 0 0 1-64-64V64a64 64 0 0 1 64-64h896a64 64 0 0 1 64 64v896a64 64 0 0 1-64 64z m-576-64h256v-256H384v256z m0-320h256V448H384v192z m-320 256a64 64 0 0 0 64 64h192v-256H64v192z m0-256h256V448H64v192z m896-512a64 64 0 0 0-64-64H128a64 64 0 0 0-64 64v256h896V128z m0 320h-256v192h256V448z m0 256h-256v256h192a64 64 0 0 0 64-64v-192z m-128-576a64 64 0 0 1 64 64v64a64 64 0 0 1-128 0V192a64 64 0 0 1 64-64zM512 320a64 64 0 0 1-64-64V192a64 64 0 0 1 128 0v64a64 64 0 0 1-64 64zM192 320a64 64 0 0 1-64-64V192a64 64 0 0 1 128 0v64a64 64 0 0 1-64 64z\" p-id=\"890\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plan.svg
// module id = 0Ex+
// module chunks = 56